import $ from 'jquery';

function ItemSlider(){
    // selectors


    // console.log(secondRound);
    

    // events
    $('section.elements-list').each(function(){
        var elementsList = $(this);
        var roundsDiv = elementsList.find('.top .right .rounds');
        var arrowNext = elementsList.find(".fa-arrow-right");
        var arrowPrev = elementsList.find(".fa-arrow-left");
        var slider = elementsList.find('.elements');
        var slide = slider.find('.element-container');
        var slideWidth = slide.outerWidth(true);
        var numberOfSlides = slide.length;
        var slidesPosition = 0;


        setUpSlider();
        var firstRound = elementsList.find('.rounds .round:first-child');
        var secondRound = elementsList.find('.rounds .round:nth-child(2)');
        var thirdRound = elementsList.find('.rounds .round:last-child');
        arrowNext.on('click', nextSlide);
        arrowPrev.on('click', prevSlide);


            // functions
    function setUpSlider(){
        if(numberOfSlides == 1){
            roundsDiv.append('<div class="round active"></div>');
        }
        else if(numberOfSlides == 2){
            roundsDiv.append('<div class="round active"></div><div class="round"></div>');
        }else{
            roundsDiv.append('<div class="round active"></div><div class="round"></div><div class="round"></div>');
        }
    }

    function nextSlide(){
        if(slidesPosition < numberOfSlides - 1){
            slidesPosition++;
            // console.log(slidesPosition)
            slider.animate({marginLeft:"-"+ slideWidth * slidesPosition +"px"},200);
            if(slidesPosition == numberOfSlides - 1){
                arrowNext.addClass('disabled');
                firstRound.removeClass('active');
                secondRound.removeClass('active');
                thirdRound.addClass('active');
            }
            if(slidesPosition == 1){
                arrowPrev.removeClass('disabled');
                firstRound.removeClass('active');
                thirdRound.removeClass('active');
                secondRound.addClass('active');
            }
        }
    }

    function prevSlide(){
        if(slidesPosition > 0){
            if(numberOfSlides == 2){
                arrowNext.removeClass('disabled');
                arrowPrev.addClass('disabled');
                thirdRound.removeClass('active');
                firstRound.addClass('active');
                slidesPosition--;
                slider.animate({marginLeft:"-"+ slideWidth * slidesPosition +"px"},200);
            }else{
                slidesPosition--;
                slider.animate({marginLeft:"-"+ slideWidth * slidesPosition +"px"},200);
                if(slidesPosition == 0){
                    arrowPrev.addClass('disabled');
                    secondRound.removeClass('active');
                    thirdRound.removeClass('active');
                    firstRound.addClass('active');
                }
                
                if(slidesPosition == numberOfSlides - 2){
                    arrowNext.removeClass('disabled');
                    secondRound.removeClass('active');
                    thirdRound.removeClass('active');
                    secondRound.addClass('active');
                }
            }
        }
    }
    })


}

export default ItemSlider;